import Backbone from 'backbone';
import React from 'react';
import ReactDOM from 'react-dom/client';

import {assert} from 'Asserts';
import BufferTabView from 'buffers/BufferTabView';
import {Sequence} from 'components/Sequence';
import {BulkSetModsParams} from 'constants/SequenceOpConstants';
import {renderToDOM, unmountRootsAsync} from 'redux-stores/ReduxDOMRender';

import {NucleotideComponent} from './MonomerConstants';
import NucleotidesTab from './NucleotidesTab';
import NucleotidesTabState from './NucleotidesTabState';

class NucleotidesTabView extends BufferTabView<NucleotidesTabState> {
  reactRoot: ReactDOM.Root | null = null;

  override initialize(): void {
    this.listenTo(
      this.model.sequence().get('_sequence'),
      'change:bases change:modifiedNucleotides',
      this.render.bind(this)
    );
  }

  override render(): Backbone.View<NucleotidesTabState> {
    if (!(this.model.sequence() instanceof Sequence)) {
      throw new Error('Can only open nucleotides tab for sequence');
    }
    const sequence = this.model.sequence();

    this.reactRoot = renderToDOM(
      <NucleotidesTab
        areEditsEnabled={sequence.allowResidueEdits()}
        bases={sequence.bases()}
        nucleotideType={sequence.nucleotideType()}
        sequenceId={this.model.sequence().id}
        onUpdateMod={async (position, monomerId, monomerType) => {
          assert(
            monomerType === NucleotideComponent.PHOSPHATE || monomerId != null,
            'Can only specify null monomer for phosphate'
          );
          switch (monomerType) {
            case NucleotideComponent.SUGAR: {
              sequence.setSugarMod(position, monomerId!);
              break;
            }
            case NucleotideComponent.PHOSPHATE: {
              sequence.setPhosphateMod(position, monomerId);
              break;
            }
            case NucleotideComponent.BASE: {
              await sequence.setBaseMod(position, monomerId!);
              break;
            }
            default: {
              assert(false, 'Unexpected nucleotide component');
            }
          }
        }}
        onBulkUpdateMods={(params: BulkSetModsParams) => {
          sequence.bulkSetMods(params);
        }}
      />,
      this.el,
      this.reactRoot
    );
    return this;
  }

  override removeAsync(callback: () => void): this {
    unmountRootsAsync([this.reactRoot], () => {
      this.reactRoot = null;
      super.remove();
      callback();
    });
    return this;
  }
}

NucleotidesTabView.prototype.className = 'buffer-tab';

export default NucleotidesTabView;
